import i from 'icepick'
import analytics from 'features/Analytics/Analytics.utils'

const initialState = {
  availableNumbers: [],
  availableNumbersGetLoading: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'NUMBERS_1800/GET_AVAILABLE_NUMBERS_PENDING':
      return i.assoc(state, 'availableNumbersGetLoading', true)
    case 'NUMBERS_1800/GET_AVAILABLE_NUMBERS_REJECTED':
      return i.assoc(state, 'availableNumbersGetLoading', false)
    case 'NUMBERS_1800/GET_AVAILABLE_NUMBERS_FULFILLED':
      return i
        .chain(state)
        .assoc('availableNumbers', action.payload.data)
        .assoc('availableNumbersGetLoading', false)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers1800/Numbers1800.reducer.js